<template>
  <div class="float-right">
    <el-badge is-dot :hidden="filtersEmpty()">
      <el-button class="btn-main" icon="el-icon-search" @click="dialog = true">
        Filters
      </el-button>
    </el-badge>
    <el-dialog
      title="Filters"
      :visible.sync="dialog"
      width="500px"
      top="3vh"
      :modal="false"
    >
      <el-input
        type="text"
        v-model="title"
        clearable
        @clear="filter()"
        @keyup.native.enter="filter()"
        placeholder="Title"
      />
      <el-input
        v-if="admin_role"
        type="text"
        v-model="artist"
        class="mt10"
        clearable
        @clear="filter()"
        @keyup.native.enter="filter()"
        placeholder="Artist"
      />
      <el-date-picker
        v-model="date_range"
        type="daterange"
        class="mt10"
        unlink-panels
        range-separator="-"
        start-placeholder="Start date"
        end-placeholder="End date"
        :picker-options="dateRangeOptions"
        format="d MMMM yyyy"
        value-format="yyyy-MM-dd"
      ></el-date-picker>
      <el-switch
        v-if="admin_role"
        v-model="publish"
        class="mt10"
        :active-value="2"
        :inactive-value="1"
        active-color="#ff4949"
        inactive-color="#13ce66"
        active-text="Not Published"
        inactive-text="Published"
      ></el-switch>
      <div slot="footer">
        <el-button type="danger" size="mini" @click="clear()">
          Clear
        </el-button>
        <el-button type="success" size="mini" @click="filter()">
          Filter
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      dialog: false,
      title: '',
      artist: '',
      date_range: '',
      publish: 1
    }
  },

  computed: {
    ...mapGetters('auth', ['admin_role'])
  },

  methods: {
    ...mapActions('newReleasesTracks', ['read']),
    ...mapMutations('newReleasesTracks', ['setPage']),

    filter() {
      if (this.date_range === null) {
        this.date_range = ''
      }
      this.setPage(1)
      let filter_data = {
        title: this.title,
        artist: this.artist,
        date_start: this.date_range[0],
        date_end: this.date_range[1],
        publish: this.publish
      }
      localStorage.setItem(
        'track_new_releases_filter',
        JSON.stringify(filter_data)
      )
      this.read(filter_data)
      this.filtersEmpty()
      this.dialog = false
    },

    filtersEmpty() {
      let ls = JSON.parse(localStorage.getItem('track_new_releases_filter'))
      if (ls) {
        const { page, page_size, ...active_filters } = ls

        let f = Object.values(active_filters).filter(function(n) {
          return n > 0 || n != ''
        })

        if (f != null && f.length) return false
      }

      return true
    },

    clear() {
      this.title = ''
      this.artist = ''
      this.date_range = ''
      this.publish = 1
      localStorage.removeItem('track_new_releases_filter')
      this.read()
    }
  },

  created() {
    this.filtersEmpty()
  }
}
</script>
